<script setup lang="ts">
import {
  TabsIndicator,
  TabsList,
  TabsListProps,
  useForwardProps,
} from 'radix-vue'

interface Props extends TabsListProps {
  indicatorClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  indicatorClass: 'bg-neutral-light-2',
})
const forwarded = useForwardProps(props)
</script>

<template>
  <TabsList
    v-bind="forwarded"
    class="bg-neutral-light-10 text-neutral-dark-2 relative flex shrink-1 self-start"
  >
    <TabsIndicator
      class="transition-(width,transform) absolute top-0 bottom-0 left-0 w-(--radix-tabs-indicator-size) translate-x-(--radix-tabs-indicator-position) duration-150"
    >
      <div
        class="h-full w-full rounded-md"
        :class="indicatorClass"
      />
    </TabsIndicator>
    <slot></slot>
  </TabsList>
</template>
